'use es6';

import { createSelector } from '@reduxjs/toolkit';
import PortalIdParser from 'PortalIdParser';
import { getTrackedSignupUrl } from 'viral-links-lib/viral-tracking/viral-urls';
import { Flow } from 'signup-constants/Flow';
import { HubsTrackingAttr } from 'signup-constants/HubsTrackingAttr';
import { SignupQueryKeys } from 'signup-constants/SignupQueryKeys';
import { Intent } from 'signup-constants/Intent';
import { getWelcomeMessage } from '../getWelcomeMessage';
export const viralChatLink = createSelector([getWelcomeMessage], (welcomeMessge = {}) => {
  const isHubSpotPortal = welcomeMessge.portalId === 53;
  const portalId = welcomeMessge.portalId || PortalIdParser.get();
  const query = {
    [HubsTrackingAttr.Campaign]: 'hubspot-livechat-virality',
    [HubsTrackingAttr.Content]: 'hubspot.com',
    [HubsTrackingAttr.Medium]: 'virality',
    [SignupQueryKeys.Intent]: Intent.conversations,
    [SignupQueryKeys.OptSidebar]: 'livechat-signup',
    [SignupQueryKeys.ViralSourcePortalId]: portalId
  };
  if (!isHubSpotPortal) {
    delete query[HubsTrackingAttr.Content];
  }
  return getTrackedSignupUrl({
    flow: Flow.Crm,
    viralLinkType: 'livechat',
    additionalParams: query
  });
});